/* eslint-disable */

let debug = process.env.NODE_ENV === 'development'
import cookie from './utils/cookie'
/**
 *格式化版本
 */
function formartVersion(v) {
  let version = v || cookie('version')
  console.log(parseInt(version.split('.').join('')))
  return parseInt(version.split('.').join(''))
}
export default [
  {
    path: '/',
    redirect: to => {
      if (debug) {
        return '/test'
      } else {
        return '/water/rechargePay'
      }
    }
  },
  {
    path: '/test',  // 测试目录
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/test'))
      }, 'test')
    }
  },
  {
    path:'/bank/list',//选择开户银行界面
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/bank/list'))
      }, 'bank.list')
    }
  },
  {
    path:'/profit/hqrecord',//活期宝收支记录
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/profit/hqrecord'))
      }, 'hqrecord')
    }
  },
  {
    path:'/action/details/:OrderNo',//活期宝收支记录详情
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/action/details'))
      }, 'details')
    }
  },
  {
    path:'/action/resutlstatu/:OrderNo/:type',//转入活期宝
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/action/resutlstatu'))
      }, 'resutlstatu')
    }
  },
  {
    path:'/action/result/:OrderNo',//受理结果
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/action/result'))
      }, 'result')
    }
  },
  {
    path:'/action/bonus/:OrderNo',//分红
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/action/bonus'))
      }, 'result')
    }
  },
  {
    path:'/help/help',//帮助
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/help'))
      }, 'help')
    }
  },
  {
    path:'/help/problem',//帮助问题页面
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/problem'))
      }, 'problem')
    }
  },
  {
    path:'/help/hqbugfund',//帮助页面问题1
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/hqbugfund'))
      }, 'hqbugfund')
    }
  },
  {
    path:'/help/hqrisk',//帮助页面问题2
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/hqrisk'))
      }, 'hqrisk')
    }
  },
  {
    path:'/help/balance',//帮助页面问题3
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/balance'))
      }, 'balance')
    }
  },
  {
    path:'/help/hqprofit',//帮助页面问题4
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/hqprofit'))
      }, 'hqprofit')
    }
  },
  {
    path: '/hqpord/into', //转入活期宝
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/hqpord/into.vue'))
      },'hqpordinto')
    }
  },
  {
    path: '/hqpord/index', // 活期宝接入天天基金
    component: function (resolve) {
      resolve(require('./views/hqpord/index.vue'))
    }
  },
  {
    path: '/hqpord/original', // 活期宝原始首页
    component: function (resolve) {
      resolve(require('./views/hqpord/original.vue'))
    }
  },
  {
    path: '/hqpord/controller',
    redirect: to => {
      const {hash, params, query} = to
      if (formartVersion() > formartVersion(query.v)) {
        return {path: '/hqpord/index'}
      } else {
        return {path: '/hqpord/original'}
      }
    }
  },
  {
    path:'/profit/list',//浪花收支记录
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/profit/list'))
      },'profit.list')
    }
  },
  {
    path:'/action/index',//提现
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/action/index'))
      },'action.index')
    }
  },
  {
    path: '/hqpord/default', //未绑定活期宝页面
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/hqpord/default.vue'))
      },'hqpord.default')
    }
  },
  {
    path: '/hqpord/setting', //设置
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/hqpord/setting.vue'))
      },'hqpord.setting')
    }
  },
  {
    path: '/card/bind', //绑定银行卡
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/card/bind.vue'))
      },'card.bind')
    }
  },
  {
    path: '/account/auth', //实名认证
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/account/auth'))
      },'account.auth')
    }
  },
   {
     path: '/tips/question', //关于活期宝的问题
     component: function (resolve) {
      require.ensure([], function () {
         resolve(require('./views/tips/question'))
       },'tips.question')
     }
   },
  {
    path: '/tips/upgrade', //提现升级说明
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/tips/upgrade'))
      },'tips.upgrade')
    }
  },
  {
    path: '/help/transfer', //银行转账授权协议
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/transfer'))
      },'help.transfer')
    }
  },
  {
    path: '/water/recharge', // 浪花充值
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/water/recharge'))
      },'recharge')
    }
  },
  {
    path: '/water/rechargePay', // 浪花充值新版
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/water/rechargepay.vue'))
      },'rechargePay')
    }
  },
  {
    path: '/water/ticket', // 浪票贡周献版
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/water/ticket'))
      },'water.ticket')
    }
  },
  {
    path: '/short/fund', // 基金夜8点
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/short/fund'))
      },'short.fund')
    }
  },
  {
    path: '/water/relay', // 支付空白页
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/water/transmit.vue'))
      },'water.relay')
    }
  },
  {
    path: '/packet/red', // 我的红包
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/packet/red.vue'))
      },'packet.red')
    }
  },
  {
    path: '/hqpord/tcash', // 我的提现页面
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/hqpord/tcash.vue'))
      },'hqpord.tcash')
    }
  },
  {
    path: '/empty/fund', // 空白页，判断用户是否开户
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/empty/fund.vue'))
      },'empty.fund')
    }
  },
  {
    path: '/hqpord/detail/:ableluckymoney', // 新版收益明细
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/hqpord/detail.vue'))
      },'hqpord.detail')
    }
    /* meta: {
      keepAlive: true // 需要缓冲
    } */
  },
  {
    path: '/help/process', // 提现流程
    component: function (resolve) {
      require.ensure([], function () {
        resolve(require('./views/help/process.vue'))
      },'help.process')
    }
  }
]



// WEBPACK FOOTER //
// ./src/routers.js